
import nxModule from 'nxModule';

import templateUrl from './generate-cocree-snapshot.template.html';

import ConfirmationTemplate from 'shared/common/confirmationTemplate';
import Notification from "shared/utils/notification";
import {NxRouteService} from "routes/NxRouteService";
import {CommandService} from "shared/utils/command/command.types";
import {Branch} from 'management/BranchTypes';
import {BranchService} from "../../../service/branch.service";
import moment from 'moment';
import {IScope} from 'angular';
import Authentication from 'shared/utils/authentication';
import {CommandDescriptor, CommandStatus} from 'command/CommandTypes';
import axios from "axios";
import {PageResult} from 'tools/HttpTypes';
import Popup from 'shared/common/popup';

const EXECUTING = CommandStatus.EXECUTING;
const COMMAND_NAME ='GenerateCocreeSnapshot';

enum SUBMISSION_TYPE {
  NEW = 'NEW',
  UPDATE = 'UPDATE'
}
 
class GenerateCocreeSnapshot {
   readonly submissionTypes: Record<string, string>[] = [
    {label: 'Maiden', type: SUBMISSION_TYPE.NEW},
    {label: 'Subsequent', type: SUBMISSION_TYPE.UPDATE}
  ];

  branch?: Branch;
  branches: Record<string, string>[] = [];
  selectedBranches?: number[] = [];
  reportDate!: Date;
  submissionType!: string;
 
  constructor(private $route: NxRouteService,
              private branchService: BranchService,
              private confirmationTemplate: ConfirmationTemplate,
              private $scope: IScope,
              private popup: Popup,
              private command: CommandService,
              private authentication: Authentication,
              private notification: Notification) {}

  async $onInit(): Promise<void> { 

    const allBranches = await this.branchService.toPromise();

    this.branches = [
      ...this.branches,
      ...allBranches.map(branch => ({
        value: branch.id.toString(),
        label: branch.name
      }))
    ];

    this.selectedBranches = [...this.branches.map(b => Number(b.value))];

    this.$scope.$watch(() => this.reportDate, (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        this.reportDate = newVal;
      }
    });
  }

  isMonthEnd(date: Date): boolean {
    if (!date) return false;
    const selected = moment(date);
    const lastDayOfMonth = selected.clone().endOf('month').date();
    return selected.date() === lastDayOfMonth;
  }

  async checkUserTriggeredCommand(): Promise<boolean> { 
    let executedCmds: CommandDescriptor[] = [];
    const userId = this.authentication.context.id;
    const cmdApi = `/command/user/${userId}?includePrints=true&statuses=${EXECUTING}`;
    const fetchResult = await axios.get<PageResult<CommandDescriptor>>(cmdApi);
    if(fetchResult.data &&  typeof fetchResult.data === "object") {
      const {result} = fetchResult.data;
      executedCmds = result.filter((c: {simpleName: string;}) => c.simpleName === COMMAND_NAME);
    }
    return !executedCmds;
  }

 
  async execute(): Promise<void> {

    if(!this.branches) return;
    
    const hasTriggeredCmd = await this.checkUserTriggeredCommand();

    if(hasTriggeredCmd) {
      this.notification.show("Error", `A COCREE snapshot is already being generated. 
        \nPlease wait until the current process completes before starting a new one.
        \nTo view the ongoing generation, please go to Dashboard → Actions → Executed Actions Tab.`);
      return;
    }
    
    const confirmed = await this.confirmationTemplate({
      question: `Existing cocree snapshots (if any) for the selected date will be overwritten. Proceed?`,
      details: [
        {label: 'Date', description: this.reportDate.toLocaleDateString()}
      ]
    });

    if(confirmed) {

      const branchesIds = this.selectedBranches?.map(branch => Number(branch)) ?? null;
      const formattedDateFilter = moment(this.reportDate).format("YYYY-MM-DD");

      const response = await this.command.execute('GenerateCocreeSnapshot', {
        branchIds: branchesIds,
        endDate: formattedDateFilter,
        submissionType: this.submissionType,
        snapshotLoan: this.isMonthEnd(this.reportDate)
      }).toPromise();

      this.popup({
        header: 'COCREE Snapshot generation started',
        text: `Please track progress in Dashboard - Actions - Executed Actions.`
      });
 
      if(!response.approvalRequired) {
        this.$route.reload();
      }
    }
  }
}

nxModule.component('generateCocreeSnapshot', {
  templateUrl,
  controller: GenerateCocreeSnapshot
});

